import * as React from 'react';
import { IgcQueryBuilderComponent as Component } from 'igniteui-webcomponents-grids/grids/index.js';
import type { IgcQueryBuilderComponentEventMap } from 'igniteui-webcomponents-grids/grids/index.js';
import { type EventName, createComponent } from '../react-props.js';

/**
 * A component used for operating with complex filters by creating or editing conditions  and grouping them using AND/OR logic.  It is used internally in the Advanced Filtering of the Grid.
 * @fires expressionTreeChange - Event fired as the expression tree is changed.
 * @class
 */
export const IgrQueryBuilder = /* @__PURE__ */ createComponent({
  tagName: 'igc-query-builder',
  displayName: 'IgrQueryBuilder',
  elementClass: Component,
  react: React,
  moveBackOnDelete: true,
  events: {
    onExpressionTreeChange: 'expressionTreeChange' as EventName<
      IgcQueryBuilderComponentEventMap['expressionTreeChange']
    >,
  },
  renderProps: { searchValueTemplate: 'searchValueTemplate' },
});

export type IgrQueryBuilder = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrQueryBuilderModule = Component;
